<div class="patient-overview-container">
  <!-- #region Medical History (Anamnese) -->
  <mat-list class="patient-overview-section section-medical-history">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.anamnesis.title' | translate
      }}</span>
      <button
        class="action-button"
        (click)="addNewVc('form_anamnesis.json', 'anamnesis', vcPatientDetails)"
        *ngIf="!caseOverview?.medical_history?.data"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        [clipToWhenSmall]="1"
        [list]="[caseOverview?.medical_history]"
        [showButton]="false"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_anamnesis.json',
                'anamnesis',
                caseOverview?.medical_history,
                vcPatientDetails,
                patientDetailsI18n,
                caseOverview?.medical_history?.history
              )
            "
            *ngIf="item?.data?.medical_history; else noContent"
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data?.medical_history || '-' }}
            </div>
            <div class="patient-overview-item-line">
              {{ item?.data?.date | date: ('GENERAL.date_time_format' | translate) || '-' }}
            </div>
          </div>
        </ng-template>
        <ng-template #noContent>
          <div class="patient-details-container-content no-content-message">
            <mat-icon>info_outline</mat-icon>
            <p>{{ 'GENERAL.no_content_label' | translate }}</p>
          </div>
        </ng-template>
      </app-dynamic-list>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Diagnostic -->
  <mat-list class="patient-overview-section section-diagnostic">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.diagnostics.title' | translate
      }}</span>
      <button
        class="action-button"
        (click)="addNewVc('form_diagnostics.json', 'diagnostic', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.diagnostic?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.diagnostic ?? []"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_diagnostics.json',
                'diagnostic',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data.title || '-' }}
            </div>
            <div class="patient-overview-item-line">
              {{
                item?.created_at
                  ? (item?.created_at | date: ('GENERAL.date_time_format' | translate))
                  : '-'
              }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>
      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Tasks -->
  <!-- #region Tasks -->
  <mat-list class="patient-overview-section section-tasks">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">
        {{
          'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.tasks.title'
            | translate: { count: caseOverview?.task?.length }
        }}
        <span class="count-badge" *ngIf="caseOverview?.task?.length">{{
          caseOverview?.task?.length
        }}</span>
      </span>
      <button
        class="action-button"
        (click)="addNewVc('form_tasks.json', 'task', vcPatientDetails)"
        (keydown.enter)="addNewVc('form_tasks.json', 'task', vcPatientDetails)"
        mat-icon-button
        aria-label="Add new task"
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.task?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.task ?? []"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_tasks.json',
                'task',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            (keydown.enter)="
              updateVc(
                item?.data,
                'form_tasks.json',
                'task',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
            role="button"
            tabindex="0"
            aria-label="View task details"
          >
            <div class="flex row gap-2 items-center">
              <mat-icon
                *ngIf="item?.data.priority === 'high' || item?.data.priority === 'veryHigh'"
                class="task-open-icon"
                [ngClass]="{ 'color-danger': item?.data.priority === 'veryHigh' }"
                matListItemIcon
              >
                priority_high
              </mat-icon>

              <div class="patient-overview-item-title" ellipsis>
                {{ item?.data.task_name || '-' }}
              </div>
            </div>

            <div class="patient-overview-item-line">
              {{
                item?.updated_at || item?.created_at
                  | date: ('GENERAL.date_time_format' | translate) || '-'
              }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>

      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Diagnosis -->
  <mat-list class="patient-overview-section section-diagnosis">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.diagnoses.title' | translate
      }}</span>
      <button
        *ngIf="!caseOverview?.diagnose?.data?.diagnose"
        class="action-button"
        (click)="addNewVc('form_diagnoses.json', 'diagnoses', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        [clipToWhenSmall]="1"
        [list]="[caseOverview?.diagnose]"
        [showButton]="false"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_diagnoses.json',
                'diagnoses',
                caseOverview?.diagnose,
                vcPatientDetails,
                patientDetailsI18n,
                caseOverview?.diagnose?.history
              )
            "
            *ngIf="item?.data?.diagnose; else noContent"
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data?.diagnose || '-' }}
            </div>
            <div class="patient-overview-item-line">
              {{ item?.data.created_at | date: ('GENERAL.date_time_format' | translate) || '-' }}
            </div>
          </div>
          <ng-template #noContent>
            <div class="patient-details-container-content no-content-message">
              <mat-icon>info_outline</mat-icon>
              <p>{{ 'GENERAL.no_content_label' | translate }}</p>
            </div>
          </ng-template>
        </ng-template>
      </app-dynamic-list>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Consultations (Konsile) -->
  <mat-list class="patient-overview-section section-consultations">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">
        {{
          'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.consultations.title'
            | translate: { count: caseOverview?.consultation?.length }
        }}
        <span class="count-badge" *ngIf="caseOverview?.consultation?.length">{{
          caseOverview?.consultation?.length
        }}</span>
      </span>
      <button
        class="action-button"
        (click)="addNewVc('form_consultations.json', 'consultations', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.consultation?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.consultation ?? []"
      >
        <ng-template let-item="item">
          <div
            class="patient-details-container-content"
            (click)="
              updateVc(
                item?.data,
                'form_consultations.json',
                'consultations',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data.title || '-' }}
            </div>
            <div class="patient-overview-item-line" ellipsis>
              {{ item?.data.details || '-' }}
            </div>
            <div class="patient-overview-item-line">
              {{
                item?.created_at
                  ? (item?.created_at | date: ('GENERAL.date_time_format' | translate))
                  : '-'
              }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>
      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Discharge -->
  <mat-list class="patient-overview-section section-discharge">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.discharge.title' | translate
      }}</span>
      <button
        *ngIf="!caseOverview?.discharge?.length"
        class="action-button"
        (click)="addNewVc('form_discharge.json', 'discharge', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.discharge?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.discharge ?? []"
        [showButton]="false"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_discharge.json',
                'discharge',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{
                item?.data.dismissalExpectedOn
                  ? (item?.data.dismissalExpectedOn | date: ('GENERAL.date_format' | translate))
                  : '-'
              }}
            </div>
            <div class="patient-overview-item-line">
              {{ item?.created_at | date: ('GENERAL.date_time_format' | translate) || '-' }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>
      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Therapy -->
  <mat-list class="patient-overview-section section-therapy">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.therapy.title' | translate
      }}</span>
      <button
        class="action-button"
        (click)="addNewVc('form_therapy.json', 'therapy', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.therapy?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.therapy ?? []"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_therapy.json',
                'therapy',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data.title || '-' }},
              {{
                item?.data.goalDateOn
                  ? (item?.data.goalDateOn | date: ('GENERAL.date_time_format' | translate))
                  : ''
              }}
            </div>
            <div class="patient-overview-item-line">
              {{
                item?.data.created_at
                  ? (item?.data.created_at | date: ('GENERAL.date_time_format' | translate))
                  : ''
              }}
              <span>{{ item?.data.conducted ? '(D)' : item?.data.registered ? '(A)' : '' }}</span>
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>

      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Pathogen -->
  <mat-list class="patient-overview-section section-pathogen">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.pathogen.title' | translate
      }}</span>
      <button
        class="action-button"
        (click)="addNewVc('form_pathogen.json', 'pathogen', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.pathogen?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.pathogen ?? []"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_pathogen.json',
                'pathogen',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data.name || '-' }}
            </div>
            <div class="patient-overview-item-line" ellipsis>
              {{
                'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.pathogen.label_type'
                  | translate: { type: item?.data.type || '-' }
              }}
            </div>
            <div class="patient-overview-item-line">
              {{
                item?.created_at
                  ? (item?.created_at | date: ('GENERAL.date_time_format' | translate))
                  : '-'
              }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>

      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Post Treatment -->
  <mat-list class="patient-overview-section section-post-treatment">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">
        {{
          'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.postTreatment.title'
            | translate: { count: caseOverview?.post_treatment?.length }
        }}
        <span class="count-badge" *ngIf="caseOverview?.post_treatment?.length">{{
          caseOverview?.post_treatment?.length
        }}</span>
      </span>
      <button
        class="action-button"
        (click)="addNewVc('form_postTreatment.json', 'postTreatment', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        *ngIf="caseOverview?.post_treatment?.length; else noContent"
        [clipToWhenSmall]="1"
        [list]="caseOverview?.post_treatment ?? []"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_postTreatment.json',
                'postTreatment',
                item,
                vcPatientDetails,
                item?.i18n,
                item?.history
              )
            "
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title" ellipsis>
              {{ item?.data?.postTreatment || '-' }}
            </div>

            <div class="patient-overview-item-line">
              {{
                item?.created_at
                  ? (item?.created_at | date: ('GENERAL.date_time_format' | translate))
                  : '-'
              }}
            </div>
          </div>
        </ng-template>
      </app-dynamic-list>

      <ng-template #noContent>
        <div class="patient-details-container-content no-content-message">
          <mat-icon>info_outline</mat-icon>
          <p>{{ 'GENERAL.no_content_label' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </mat-list>
  <!-- #endregion -->

  <!-- #region Visite (Optional, will appear if data exists) -->
  <mat-list *ngIf="caseOverview?.visit_record?.data" class="patient-overview-section section-visit">
    <div class="patient-overview-container-title" mat-subheader>
      <span class="title-text">{{
        'COMPONENT.DIALOG_PATIENT_OVERVIEW.patientDetails.visit.title' | translate
      }}</span>
      <button
        *ngIf="!caseOverview?.visit_record?.data"
        class="action-button"
        (click)="addNewVc('form_visit.json', 'visit', vcPatientDetails)"
        mat-icon-button
      >
        <mat-icon class="action-icon">add</mat-icon>
      </button>
    </div>
    <div class="section-content">
      <app-dynamic-list
        [clipToWhenSmall]="2"
        [list]="[caseOverview?.visit_record]"
        [showButton]="false"
      >
        <ng-template let-item="item">
          <div
            (click)="
              updateVc(
                item?.data,
                'form_visit.json',
                'visit',
                caseOverview?.visit_record,
                vcPatientDetails,
                patientDetailsI18n,
                caseOverview?.visit_record?.history
              )
            "
            *ngIf="item?.data; else noContent"
            class="patient-details-container-content"
          >
            <div class="patient-overview-item-title">
              {{ item?.data.note || '-' }}
            </div>
            <div class="patient-overview-item-line">
              {{ item?.data.date_and_time | date: ('GENERAL.date_time_format' | translate) || '-' }}
            </div>
          </div>
          <ng-template #noContent>
            <div class="patient-details-container-content no-content-message">
              <mat-icon>info_outline</mat-icon>
              <p>{{ 'GENERAL.no_content_label' | translate }}</p>
            </div>
          </ng-template>
        </ng-template>
      </app-dynamic-list>
    </div>
  </mat-list>
  <!-- #endregion -->
</div>
